import { Routes } from '@angular/router';
import { LoginComponent } from './modules/auth/components/login/login.component';

const MODULE_ROUTES = [
    { path: 'auth', loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule) }
  ];

export const routes: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule),
      }  ,
      {
        path:'',
        pathMatch: 'full',
        redirectTo: '/auth',
    },
    {
        path:'**',
        pathMatch: 'full',
        redirectTo: '/auth',
    }
    
];
